enum ENotificationTypes {
  'info',
  'confirmation',
  'formError',
}

export default ENotificationTypes;
